import React, { memo } from 'react'

import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import FiltersWrapper from 'Pods/Shared/FiltersWrapper/FiltersWrapper'

function Features() {
  const translate = useTranslate()

  // Placeholder dropdown; its contents are defined in a follow-up subtask.
  const content = (
    <div className="secondary-filters__dropdown-placeholder cgt-body-base">
      {translate('search_page.filters.under_construction')}
    </div>
  )

  return (
    <FiltersWrapper
      placeholder={translate('search_page.filters.features.title')}
      content={content}
      closingDropdownClassName="filter-wrapper"
    />
  )
}

export default memo(Features)
